import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadDynamicSidebar(action) {
  try {
    const {
      data: { accessToken, ...payload },
    } = action.payload

    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/dynamic-sidebar`,
      {
        ...payload,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )

    yield put(
      actions.loadDynamicSidebar.success(res.data, action.payload.data.page),
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadDynamicSidebar.failure())
  }
}

function* loadDynamicSidebarDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/dynamic-sidebar/detail/${id}`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.loadDynamicSidebarDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadDynamicSidebarDetail.failure())
  }
}

function* createDynamicSidebar(action) {
  const {
    data: { accessToken, ...payload },
    cb,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/dynamic-sidebar/create`,
      {
        ...payload,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    cb(res.data)
    yield put(actions.createDynamicSidebar.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.createDynamicSidebar.failure())
  }
}

function* updateDynamicSidebar(action) {
  const {
    data: { accessToken, ...payload },
    cb,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/dynamic-sidebar/update`,
      {
        ...payload,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    cb(res.data)

    yield put(actions.updateDynamicSidebar.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.updateDynamicSidebar.failure())
  }
}

function* deleteDynamicSidebar(action) {
  const {
    data: { accessToken, ...payload },
    cb,
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/dynamic-sidebar/delete`,
      {
        ...payload,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    cb(res.data)

    yield put(actions.deleteDynamicSidebar.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.deleteDynamicSidebar.failure())
  }
}

function* loadDynamicSidebarMenuHierarchy(action) {
  const {
    data: { accessToken, ...payload },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/dynamic-sidebar/master-menu-hierarchy`,
      {
        ...payload,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )

    yield put(actions.loadDynamicSidebarMenuHierarchy.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadDynamicSidebarMenuHierarchy.failure())
  }
}

export default function* watchDynamicSidebarState() {
  yield all([
    takeEvery(actions.LOAD_DYNAMIC_SIDEBAR.REQUEST, loadDynamicSidebar),
    takeEvery(
      actions.LOAD_DYNAMIC_SIDEBAR_DETAIL.REQUEST,
      loadDynamicSidebarDetail,
    ),
    takeEvery(actions.CREATE_DYNAMIC_SIDEBAR.REQUEST, createDynamicSidebar),
    takeEvery(actions.UPDATE_DYNAMIC_SIDEBAR.REQUEST, updateDynamicSidebar),
    takeEvery(actions.DELETE_DYNAMIC_SIDEBAR.REQUEST, deleteDynamicSidebar),
    takeEvery(
      actions.LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY.REQUEST,
      loadDynamicSidebarMenuHierarchy,
    ),
  ])
}

export {
  loadDynamicSidebar,
  loadDynamicSidebarDetail,
  createDynamicSidebar,
  updateDynamicSidebar,
  deleteDynamicSidebar,
  loadDynamicSidebarMenuHierarchy,
}
